import React from 'react';
var SearchIcon = function SearchIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.193 15.607A7.002 7.002 0 015.05 5.05a7 7 0 0110.557 9.143l4.146 4.146a1 1 0 11-1.414 1.414l-4.146-4.146zM7.5 14.33a5 5 0 115-8.66 5 5 0 01-5 8.66z",
    fill: "#000"
  }));
};
export default SearchIcon;